import {createIntlSegmenterPolyfill} from 'intl-segmenter-polyfill';

(async function () {
  if (window.Intl.Segmenter) {
    return
  }
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  window.Intl.Segmenter = await createIntlSegmenterPolyfill(
    fetch('/static/wasm/break_iterator.wasm'),
  )
})()
